<template>
  <div>
    <form>
      <h3 class="line-header">
        <img
          src="@/assets/icons/user-group.svg"
          alt="Icone entreprise"
        > {{ $t('forms.group.title') }}
      </h3>
      <!-- NAME -->
      <div
        v-if="isFieldVisible('name', formConfig.hiddenFields)"
        class="form-row"
      >
        <div class="form-group col-12">
          <label :class="isFieldRequired('name', formConfig.requiredFields)">
            {{ $t('forms.group.name.label') }}
          </label>
          <p>
            {{ $t('forms.group.name.help') }}
          </p>
          <ValidationProvider
            v-slot="{ classes, errors }"
            ref="display_name"
            :rules="isFieldRequired('name', formConfig.requiredFields)"
          >
            <div
              class="control"
              :class="classes"
            >
              <input
                v-model="formData.display_name"
                v-sanitize
                class="form-control"
                type="text"
                :placeholder="$t('forms.group.name.label')"
              >
              <span class="form-errors">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>
      <!-- DESCRIPTION -->
      <div
        v-if="isFieldVisible('description', formConfig.hiddenFields)"
        class="form-row"
      >
        <div class="form-group col-12">
          <label :class="isFieldRequired('description', formConfig.requiredFields)">
            {{ $t('forms.group.description') }}
          </label>
          <ValidationProvider
            v-slot="{ classes, errors }"
            ref="display_name"
            :rules="isFieldRequired('description', formConfig.requiredFields)"
          >
            <div
              class="control"
              :class="classes"
            >
              <textarea
                v-model="formData.description"
                v-sanitize
                class="form-control"
              />
              <span class="form-errors">{{ errors[0] }}</span>
            </div>
          </ValidationProvider>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { ValidationProvider, extend, configure } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';
extend('required', {
  ...required,
  message: 'Ce champ est requis'
});
configure({
  classes: {
    valid: 'is-valid',
    invalid: 'is-invalid'
  }
});

export default {
  name: 'GroupForm',

  components: {
    ValidationProvider
  },

  props: {
    group: {
      type: Object,
      default: () => { return {}; }
    }
  },

  data() {
    return {
      formData: {
        display_name: null,
        description: null
      }
    };
  },

  computed: {
    ...mapState('usergroups', ['currentUsergroup']),

    formConfig() {
      return this.$config.forms.user;
    },
  },

  watch: {
    formData: {
      deep: true,
      handler(newValue) {
        this.$emit('update', {
          ...this.currentUsergroup,
          ...newValue.display_name && { display_name: newValue.display_name },
          ...newValue.description && { description: newValue.description }
        });
      }
    }
  },

  created() {
    this.formData.display_name = this.group.display_name;
    this.formData.description = this.group.description;
  },

  methods: {
    saveGroup() {
      const data = {
        ...this.currentUsergroup,
        ...this.formData.display_name && { display_name: this.formData.display_name },
        ...this.formData.description && { description: this.formData.description }
      };
      this.$emit('save', data);
    }
  }
};
</script>
